import React from 'react';
import { View, StyleSheet } from '@react-pdf/renderer';
import InvoiceTableHeader from './InvoiceTableHeader';
import InvoiceTableRow from './InvoiceTableRow';
import InvoiceTableBlankSpace from './InvoiceTableBlankSpace';
import InvoiceTableFooter from './InvoiceTableFooter';

const tableRowsCount = 11;

const styles = StyleSheet.create({
  tableContainer: {
    // marginTop: 10,
    // borderWidth: 1,
    // borderColor: '#C8C8C8',
    // paddingHorizontal: 20,
    // paddingVertical: 10,
  },
});

const InvoiceItemsTable = ({ invoice }) => (
  <View style={styles.tableContainer}>
    <InvoiceTableHeader />
    <InvoiceTableRow items={invoice} />
    {/* Uncomment when needed */}
    {/* <InvoiceTableBlankSpace rowsCount={tableRowsCount} /> */}
    {/* <InvoiceTableFooter items={invoice.items} /> */}
  </View>
);

export default InvoiceItemsTable;
